import { createCrudSlice } from '../../../../data/store/create-crud-slice';
import Case from './Case';

const caseSlice = createCrudSlice<Case>('cases');
export const { removeItem, createItem, updateItem, setItems } = caseSlice.actions;

export default caseSlice;